import { render, staticRenderFns } from "./application-value-SupplierEvaluationSystem.vue?vue&type=template&id=132f7c65&scoped=true"
import script from "./application-value-SupplierEvaluationSystem.vue?vue&type=script&lang=js"
export * from "./application-value-SupplierEvaluationSystem.vue?vue&type=script&lang=js"
import style0 from "./application-value-SupplierEvaluationSystem.vue?vue&type=style&index=0&id=132f7c65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f7c65",
  null
  
)

export default component.exports